<template>
  <section>
    <HeroSection headName="Envios" goLabel="Cadastrar Envio" goRoute="/envios/f" :searchBar="true" :addButton="true" :hasDownload="false" @makeDownload="makeDownload">
      <div class="searchbar__wrap">
        <FormSelect label="Usuário" :required="false" :dataList="usersListData" v-model:modelValue="filters.usuario" classPrefix="searchbar" v-if="isUserAdmin()" />

        <div class="searchbar__group">
          <label for="" class="searchbar__label">
            Pesquisar:
          </label>

          <input class="searchbar__input searchbar__input--cliente" type="text" v-model="filters.search" @keyup.enter="doSearch()" >
        </div>
      </div>
    </HeroSection>

    <div class="container">

      <div class="table">
        <DataLoading rows="5" height="100px" v-if="loading"/>

        <NoData v-if="!loading && dataList.length == 0"/>

        <div class="table__responsive" v-if="!loading && dataList.length">
          <table>
            <thead>
              <tr>
                <th class="a-center">#</th>
                <th class="a-left">Utilizador</th>
                <th class="a-left">Assunto da Mensagem</th>
                <th class="a-center">Status</th>
                <th class="a-center">Fila de Envio</th>
                <th class="a-center">Última Alteração</th>
                <th class="a-center">Data de Criação</th>
                <th class="a-center">-</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in dataList" :key="index">
                <td class="a-center">{{ counterDocs(pagination, index) }}</td>
                <td class="table__box">
                  <div class="table__lbox">
                    <img v-if="!item.sender.senderImage" :src="baseUrl('/img/user.jpg')" :alt="item.sender.senderName">
                    <img v-if="item.sender.senderImage" :src="item.sender.senderImage" :alt="item.sender.senderName">
                  </div>

                  <div class="table__rbox">
                    <span>
                      {{ item.sender.senderName }}
                    </span>

                    <span>
                      {{ item.sender.senderReplyToEmail }}
                    </span>

                    <span :style="`color: ${userTypes(item.sender.senderAwsConfig, 'color')}`">
                      {{ userTypes(item.sender.senderAwsConfig, 'label') }}
                    </span>
                  </div>
                </td>
                <td class="a-left">
                  {{ item.subjectContent }}
                </td>
                <td class="a-center">
                  <BadgetInfo :label="shipStatus(item.shipStatus, 'label')" :color="shipStatus(item.shipStatus, 'color')" />
                </td>
                <td class="a-center">
                  {{ item.numQueue }}
                </td>
                <td class="a-center">
                  {{ brDate(item.updatedAt) }}
                </td>
                <td class="a-center">
                  {{ brDate(item.createdAt) }}
                </td>
                <td class="a-center">
                  <router-link class="table__go" :to="`/envios/f/${item._id}`" title="Editar">
                    <font-awesome-icon :icon="['fas', 'pen-fancy']" />
                  </router-link>

                  <router-link class="table__go" :to="`/enviar/f/${item._id}`" title="Editar" style="margin-left: 10px;" v-if="item.shipStatus == 'Draft'">
                    <font-awesome-icon :icon="['fas', 'paper-plane']" />
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <PaginationGuide prefix="envios" :data="pagination" :filters="filters" />
    </div>
  </section>
</template>

<script>

import HeroSection from '@components/_partials/HeroSection.vue';
import NoData from '@components/_partials/NoData.vue';
import DataLoading from '@components/_partials/DataLoading.vue';
import FormSelect from '@components/_form/FormSelect.vue';
import BadgetInfo from '@components/_partials/BadgetInfo.vue';
import PaginationGuide from '@components/_partials/PaginationGuide.vue';
import { baseUrl, cutString, padVal, brDate, docMask, csvDownload, counterDocs } from '@helpers/functions';
import { userTypes, shipStatus } from '@helpers/constants';
import storage from 'storage';
import envio from '@services/envio';
import usuario from '@services/usuario';

export default {
  components: {
    HeroSection,
    PaginationGuide,
    NoData,
    BadgetInfo,
    FormSelect,
    DataLoading
  },
  methods: {
    baseUrl,
    cutString,
    brDate,
    padVal,
    docMask,
    counterDocs,
    userTypes,
    shipStatus,
    initLoad() {
      const _this = this;
      const { usuario, search } = _this.filters;
      const params = {
        page: _this.$route.query.page ? _this.$route.query.page : null,
        usuario,
        search
      };

      _this.loading = true;
      envio.retrieve(params).then((res) => {
        _this.loading = false;

        if(typeof res !== 'undefined' && res.success) {
          const { docs, ...pagination } = res.data;
          _this.dataList = docs;
          _this.pagination = pagination;
        }
      });
    },
    doSearch() {
      const _this = this;
      const search = _this.filters.search;
      if(search.length > 3) {
        _this.initLoad();
        _this.filters.search = '';
      }
      if(!search.length) {
        _this.initLoad();
      }
    },
    mountQueryString() {
      const _this = this;
      const { usuario, status } = _this.$route.query;

      _this.filters = {
        usuario,
        status
      }
    },
    goToWithQueryString(key, filter) {
      let path = 'envios';
      let { ...queries } = this.$route.query;

      queries[key] = filter;
      this.$router.push({
        path,
        query: queries
      });
    },
    makeDownload() {
      const _this = this;
      _this.loading = true;

      envio.export().then((res) => {
        _this.loading = false;
        csvDownload(res, 'contatos.csv');
      });
    },
    isUserAdmin() {
      const local = 'mail4fly--user';
      const user = storage.get(local);
      return user && user.role === 'admin' ? true : false;
    },
    usersList() {
      const _this = this;

      if(!_this.isUserAdmin()) return false;

      usuario.retrieve().then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          const users = res.data.docs.map(item => ({
            label: `${item.senderName} - ${userTypes(item.senderAwsConfig, 'label')}`,
            value: item._id
          }));

          _this.usersListData = users;
        }
      });
    }
  },
  data() {
    return {
      loading: false,
      dataList: [],
      pagination: {},
      filters: {},
      usersListData: []
    }
  },
  watch: {
    'filters.usuario'(periodo) {
      this.goToWithQueryString('usuario', periodo);
    }
    ,
    'filters.status'(status) {
      this.goToWithQueryString('status', status);
    }
  },
  mounted(){
    this.usersList();
    this.mountQueryString();
    this.initLoad(false);
  }
};

</script>
